import {
  useInfiniteQuery,
  UseInfiniteQueryOptions,
  InfiniteData,
} from "@tanstack/react-query";
import { axiosInterceptor } from "..";

export type IFeedbackScoreResponse = {
  data: { date: string; avgScore: number }[];
  totalPages: number;
  page: number;
};

export type IFeedbackScoreInfiniteData = InfiniteData<IFeedbackScoreResponse>;

const useFeedbackScore = (
  orgId: string,
  subUserId: string,
  config?: Partial<
    UseInfiniteQueryOptions<
      IFeedbackScoreResponse,
      Error,
      IFeedbackScoreInfiniteData
    >
  >
) => {
  return useInfiniteQuery<
    IFeedbackScoreResponse,
    Error,
    IFeedbackScoreInfiniteData
  >({
    ...config,
    queryKey: ["FEEDBACK_SCORE", orgId, subUserId],
    queryFn: async ({ pageParam }): Promise<IFeedbackScoreResponse> => {
      const queryParams = new URLSearchParams();
      if (pageParam) {
        queryParams.append("page", `${pageParam}`);
      }
      queryParams.append("limit", "5");

      const response = await axiosInterceptor.get<IFeedbackScoreResponse>(
        `progression-b2b/${orgId}/${subUserId}/feedback-score?${queryParams}`
      );
      return response.data;
    },
    getNextPageParam: (lastPage) => {
      return lastPage.page < lastPage.totalPages
        ? lastPage.page + 1
        : undefined;
    },
    refetchOnMount: "always",
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    initialPageParam: 1,
  });
};

export default useFeedbackScore;
